export * from './trim-value.directive';
